module.exports = __webpack_public_path__ + "5a166c2b01512798d1c8017501626a62.png";